<template>
    <ul class="main_body_goods_tabs">
        <li :class="{active_tabs:activeTabs == parentId}">
            <el-button
                type="text"
                size="mini"
                class="goods_tabs_btn"
                @click="handleTabs(parentId)">
                {{$t("message.main.hotGoods")}}
            </el-button>
        </li>
        <li v-for="(item, index) in newTabs"
            :key="index"
             :class="{active_tabs:activeTabs == item.id}">
            <el-button
                type="text"
                size="mini"
                class="goods_tabs_btn"
                @click="handleTabs(item.id)">
                {{item.cat_name}}
            </el-button>
        </li>
    </ul>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            // 当前选中标签
            activeTabs: this.parentId,
        }
    },
    props: [ "tabs", "parentId", "num" ],
    computed: {
        newTabs(){
            return this.tabs.slice(0, 5);
        },
    },
    methods: {
        ...mapActions([
            "getTabsGoods",
        ]),
        handleTabs(id){
            this.getTabsGoods({id,num:this.num});
            this.activeTabs = id;
        }
    },
}
</script>

<style scoped>
/* 组件盒子 */
.main_body_goods_tabs>li{
    float: left;
    margin-right: 30px;
    font-size: 18px;
}
li.active_tabs{
    border-bottom: 2px solid #ff6700;
}
/* 按钮 */
.goods_tabs_btn{
    color:#333;
}
.active_tabs>.goods_tabs_btn{
    color: #ff6700;
}
</style>
